module.exports = __webpack_public_path__ + "static/media/video_demo_play.afe729cd.png";